import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { useMachine } from '@xstate/react';
import amplitude from 'amplitude-js';
import { toggleModal, toggleModalWithTimer, toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { addExtras, setExtra } from 'apps/auth/actions/extraAction';
import {
    changeFieldProperty,
    changeFormField,
    changeFormFieldValue,
    removeFields,
    scrollToField,
    setFieldError,
    setFieldVisible,
    setNewFields,
    setNewForm,
    updateFields,
    updateFieldValues,
    updateFormProperties,
} from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { sendGtEvent } from 'apps/auth/analytics/analytics';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import Form from 'apps/auth/components/form-multi/Form';
import Disclaimer from 'apps/auth/components/send/disclaimers/Disclaimer';
import PaymentStoriesModal from 'apps/auth/components/send/modals/PaymentStoriesModal';
import GTExtraToFields from 'apps/auth/components/send/multiScreen/GTExtraToFields';
import GTFromFields from 'apps/auth/components/send/multiScreen/GTFromFields';
import GTPaymentMethods from 'apps/auth/components/send/multiScreen/GTPaymentMethods';
import GTSendModals from 'apps/auth/components/send/multiScreen/GTSendModals';
import GTToFields from 'apps/auth/components/send/multiScreen/GTToFields';
import { SendCalculatorScreen } from 'apps/auth/components/send/multiScreen/SendCalculatorScreen';
import ToSubSources from 'apps/auth/components/send/multiScreen/toSubSources/ToSubSources';
import ChangeRecipientTypeToMyself from 'apps/auth/components/send/popups/errors/ChangeRecipientTypeToMyself';
import EqualNameAndNameFPopup from 'apps/auth/components/send/popups/errors/EqualNameAndNameFPopup';
import ErrorDetailsPopup from 'apps/auth/components/send/popups/errors/ErrorDetailsPopup';
import SdkModals from 'apps/auth/components/send/SdkModals';
import {
    CALCULATOR_SCREEN,
    SENDER_ADDITIONAL_INFO_SCREEN,
    PAYMENT_METHOD_SCREEN,
    RECIPIENT_MAIN_INFO_SCREEN,
    RECIPIENT_ADDITIONAL_INFO_SCREEN,
    CARD_EXTRA_FIELDS_SCREEN,
    SUB_SOURCES_SCREEN,
    TRANSFER_ADDITIONAL_INFO_SCREEN,
} from 'apps/auth/components/send/SendConstants';
import { getIsImprovedRate, getPaymentFlow, getRecipientTypeParam, getSubSourceName, transactionMethods } from 'apps/auth/components/utils/AmplitudeUtils';
import BasePage from 'apps/auth/components/utils/BasePage';
import {
    ADDITIONAL_RECIPIENT_CONTINUE_CLICKED,
    ADDITIONAL_SENDER_INFO_CONTINUE_CLICKED,
    CALCULATOR_SETTING_CHANGED,
    MORE_DETAILS_NEEDED_CONTINUE_CLICKED,
    RECIPIENT_ADDED,
    RECIPIENT_DETAILS_CONTINUE_CLICKED,
    VIEW_RATES_FIRST,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    AMOUNT_FROM_AMPLITUDE,
    AMOUNT_TO_AMPLITUDE,
    CATEGORY,
    IS_IMPROVED_RATE,
    NETWORK,
    PAYMENT_COUNTRY,
    PAYMENT_CURRENCY,
    PAYMENT_FLOW,
    PAYMENT_METHOD_AMPLITUDE,
    PAYMENT_METHOD_CATEGORY,
    PAYOUT_COUNTRY,
    PAYOUT_CURRENCY,
    PAYOUT_METHOD,
    PAYOUT_METHOD_CATEGORY,
    RECIPIENT_TYPE,
    TRANSFER_COUNT,
} from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { NEW, RECIPIENT_ADDITIONAL_INFO, RECIPIENT_MAIN_INFO, SENDER_INFO, TRANSFER_ADDITIONAL_INFO } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import {
    BONUS,
    DELIVERY_BANK_CARD,
    DELIVERY_CASH_UNITELLER,
    DELIVERY_SWIFT,
    EXTERNAL,
    PAYMENT_ACH,
    PAYMENT_BANK_CARD,
    PAYMENT_BONUS,
    PAYMENT_MODULR,
    PAYMENT_OFAKIM,
    RECIPIENT_TYPE_SELF,
} from 'apps/auth/constants/Constants';
import {
    AMOUNT_FROM,
    AMOUNT_TO,
    FROM_ACCOUNT,
    PAN,
    PAYMENT_METHOD,
    REPEAT_PAYMENT_ID,
    SOURCE_CODE_FROM,
    TO_NAME,
    TO_NAME_F,
    TO_RECIPIENT,
    TO_RECIPIENT_OTHER,
} from 'apps/auth/constants/fieldsName';
import { SEND_FORM_NAME } from 'apps/auth/constants/formName';
import { GT_TRANSFER_REPEAT_START } from 'apps/auth/constants/GoogleAnalyticsEvents';
import {
    AUTH_BONUS_WITHDRAW,
    AUTH_PROFILE_BONUS_WITHDRAW,
    AUTH_SEND,
    AUTH_SEND_INCOMPLETE_PAYMENT_CALCULATOR_ACTION,
    AUTH_SEND_MAIN_LINK,
    AUTH_SEND_PRECHECK,
} from 'apps/auth/constants/UrlConstants';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { getExtra, toLowerCase } from 'apps/auth/helpers/utils';
import { useApp, useAuth, useErrors, useExtra, useFields, useLanguage, usePageMessages, useTypeOfTransfer } from 'apps/auth/hooks/selectors';
import { useQuery } from 'apps/auth/hooks/useQuery';
import { ApiService } from 'apps/auth/services/apiService';
import { DisclaimerService } from 'apps/auth/services/DisclaimerService';
import { GTPaymentMethodService } from 'apps/auth/services/GTPaymentMethodService';
import { getAdditionalInfo, getRecipientAdditionalFields, GTSendMultiScreenService, hasExceedLimitErrors } from 'apps/auth/services/GTSendMultiScreenService';
import { showPromoModal } from 'apps/auth/services/promoModalService';
import { sendScreenMachine } from 'apps/auth/services/SendScreenMachine';
const BIN_EXTRA_NAME = 'binInfo';

export const getFirstScreen = (query, forceShowRecipientScreen, isRepeat, extra, forceShowPaymentMethods, showCalculatorFirst) => {
    if (showCalculatorFirst) {
        return extra?.toSubSources ? SUB_SOURCES_SCREEN : CALCULATOR_SCREEN;
    } else if (forceShowRecipientScreen && !forceShowPaymentMethods) {
        return RECIPIENT_MAIN_INFO_SCREEN;
    } else if (isRepeat && !extra.precheck) {
        return forceShowPaymentMethods ? PAYMENT_METHOD_SCREEN : CALCULATOR_SCREEN;
    } else if (extra?.toSubSources && !extra.precheck) {
        return SUB_SOURCES_SCREEN;
    } else if (extra.precheck) {
        return PAYMENT_METHOD_SCREEN;
    } else {
        return RECIPIENT_MAIN_INFO_SCREEN;
    }
};

export const getInitialContextForScreenMachine = (extra, stateOptions, fields, showCalculatorFirst) => {
    const additionalInfo = getAdditionalInfo(fields, extra);
    const {
        isShowSenderAdditionalScreen,
        isShowVisibleSenderAdditionalFields,
        isShowCardExtraFields,
        hasRecipientAdditionalFields,
        hasTransferAdditionalFields,
        onlyCVV,
    } = additionalInfo;

    return {
        hasSubSources: Boolean(extra.toSubSources),
        recipientSaved: Boolean(extra.recipientSaved),
        isBonusWithdraw: Boolean(stateOptions?.isBonus),
        hasCardExtraFields: isShowCardExtraFields && !onlyCVV,
        hasSenderAdditionalFields: isShowSenderAdditionalScreen && isShowVisibleSenderAdditionalFields,
        hasRecipientAdditionalFields: hasRecipientAdditionalFields,
        hasTransferAdditionalFields: hasTransferAdditionalFields,
        showCalculatorFirst: Boolean(showCalculatorFirst),
    };
};

const GTSendMultiPage = (props) => {
    const { ballId } = useAuth();
    const messages = usePageMessages();
    const {
        showDisclaimer,
        deliveryMethod,
        isPayee,
        toCountry,
        toCurrency,
        fromCountry,
        fromCurrency,
        dcSources,
        forceShowRecipientScreen,
        resetComponent,
        userComeFromSend,
        transferMethodNotSupport,
        fieldsForShow,
        recipientSaved,
        toSubSources,
        hasSuccessUniteller,
        repeatDraft,
        incompleteTransfer,
        availablePaymentMethodsList,
        payoutCategory,
        paymentCategory,
        incompleteTransferValidationStep,
        isDisclaimerFromServerSide,
        forceShowPaymentMethods,
        sendStoriesFromProviderCategory,
        canShowAmlLevelUpgrade,
    } = useExtra();
    const extra = useExtra();
    const app = useApp();
    const { lang } = useLanguage();
    const errors = useErrors();
    const query = useQuery();
    const fields = useFields(SEND_FORM_NAME);

    let [, setSearchParams] = useSearchParams();
    const [disabledSubmitButton, setDisabledSubmitButton] = useState(true);
    const [regularFlow, toggleRegularFlow] = useState(true);
    const [disclaimerAgreed, setDisclaimerAgreed] = useState(false);
    const firstScreenRef = useRef(null);
    const isRepeat = props.stateOptions?.repeat;

    const showCalculatorFirst = extra?.profile?.showCalculatorFirst && !extra?.incompleteTransfer && !isRepeat && !props.stateOptions?.globalFlow;

    if (firstScreenRef.current === null) {
        firstScreenRef.current = getFirstScreen(query, forceShowRecipientScreen, isRepeat, extra, forceShowPaymentMethods, showCalculatorFirst);
    }

    const screenMachine = useMemo(() => {
        if (typeof __isDev__ !== 'undefined' && __isDev__) {
            logInfo('Create screen machine with first screen ' + firstScreenRef.current);
        }

        return sendScreenMachine(firstScreenRef.current, getInitialContextForScreenMachine(extra, props.stateOptions, fields, showCalculatorFirst));
    }, [firstScreenRef.current]);

    const [state, send] = useMachine(screenMachine);
    const screen = typeof state.value === 'object' ? Object.values(state.value)[0] : state.value;
    const [backUrl, setBackUrl] = useState();
    const [closeIcon, setCloseIcon] = useState(false);
    const [recipientDataChanged, setRecipientDataChanged] = useState(false);
    const submitRef = useRef(null);
    const controllerRef = useRef(null);
    const clickedOnViewRatesFirst = useRef(null);
    const toBankCodeRef = useRef(null);
    const paymentMethodService = useRef(null);
    const sendMultiScreenService = useRef(null);
    const canCalcCommission = useRef(false);
    const popupRef = useRef(null);
    const popupFullwidthRef = useRef(null);
    const modalRef = useRef(null);
    const tryToCreatePrecheckAfterCalculator = useRef(true);
    const isShowDisclaimer = useRef(!hasSuccessUniteller);
    const historyIndex = useRef(__isBrowser__ ? window?.history?.state?.index : 0);
    const paymentMethodState = useRef(null);
    const isBonus = props.stateOptions?.isBonus || fields?.[PAYMENT_METHOD]?.value === BONUS;
    const amplitudeDeliveryMethod = transactionMethods[deliveryMethod];
    const amplitudePaymentMethod = transactionMethods[fields?.paymentSourceFromMethod?.value];
    const typeOfTransfer = useTypeOfTransfer();
    const sendUriPostfix = typeOfTransfer ? `?type=${typeOfTransfer}` : '';
    const transferCount = __isBrowser__ ? localStorage.getItem('transferCount') : null;
    useEffect(() => {
        if (__isBrowser__) {
            sendMultiScreenService.current = new GTSendMultiScreenService(
                submitRef,
                paymentMethodService,
                props.stateOptions?.isBonus,
                props.stateOptions?.globalFlow,
                isRepeat,
                historyIndex.current,
                typeOfTransfer,
                ballId,
                send,
            );
            sendMultiScreenService.current.setAppActions(props.toggleModal, props.toggleSpinner, props.updateMessages);
            sendMultiScreenService.current.setExtraAction(props.addExtras);
            sendMultiScreenService.current.setUpdatePageMessagesAction(props.updatePageMessages);
            sendMultiScreenService.current.setFormActions(
                props.updateFormProperties,
                props.changeFormFieldValue,
                props.updateFields,
                props.setNewFields,
                props.setFieldError,
                props.scrollToField,
                props.setNewForm,
                props.setFieldVisible,
                props.changeFieldProperty,
                props.removeFields,
            );
            sendMultiScreenService.current.setPopups(popupRef);
            sendMultiScreenService.current.setModals(modalRef);
            sendMultiScreenService.current.updateFieldsForShowGlobalFlow(SEND_FORM_NAME, props.stateOptions?.globalFlow, isRepeat, fields, fieldsForShow);

            if (isRepeat) {
                sendGtEvent(GT_TRANSFER_REPEAT_START);
            }
            if (window?.history?.state?.html) {
                const { paymentMethodFields, paymentMethodExtra } = window?.history?.state?.html;
                if (paymentMethodFields && paymentMethodExtra) {
                    props.setExtra(paymentMethodExtra);
                    props.setNewForm(SEND_FORM_NAME, paymentMethodFields);
                    window.history.replaceState(null, '', window.location.href);
                }
            }
        }
    }, []);

    useEffect(() => {
        if (typeof __isDev__ !== 'undefined' && __isDev__) {
            logInfo('=== MACHINE UPDATE ===');
            logInfo('value:', state.value); // активное состояние
            logInfo('context:', state.context); // текущий контекст
            logInfo('event:', state.event); // последнее событие
            logInfo('changed:', state.changed); // изменилось ли состояние
        }
    }, [state]);

    useEffect(() => {
        if (__isBrowser__) {
            const handleBrowserNavigationButtonsClick = (event) => {
                const newIndex = event?.state?.index ?? 0;
                if (newIndex > historyIndex.current) {
                    switchToNextMachineScreen();
                } else {
                    onBackIconClickForMachine(event);
                }
                historyIndex.current = newIndex;
            };

            addEventListener('popstate', handleBrowserNavigationButtonsClick);
            return () => removeEventListener('popstate', handleBrowserNavigationButtonsClick);
        }
    }, [screen, toSubSources, incompleteTransfer]);

    useEffect(() => {
        sendMultiScreenService.current.setExtra(extra);
    }, [extra]);

    useEffect(() => {
        sendMultiScreenService.current.setTypeOfTransfer(typeOfTransfer);
    }, [typeOfTransfer]);

    useEffect(() => {
        paymentMethodService.current = new GTPaymentMethodService(
            props.updateFieldValues,
            props.updateFormProperties,
            SEND_FORM_NAME,
            toCountry?.code,
            toCurrency?.code,
            deliveryMethod,
            typeOfTransfer,
            incompleteTransfer,
        );
    }, [toCountry?.code, toCurrency?.code, deliveryMethod]);

    useEffect(() => {
        DisclaimerService.showDisclaimer(
            props,
            toCountry,
            toCurrency,
            isDisclaimerFromServerSide,
            deliveryMethod,
            setDisclaimerAgreed,
            Disclaimer,
            fields,
            sendUriPostfix,
            isDisclaimerFromServerSide,
            incompleteTransfer,
            toBankCodeRef.current,
        );
    }, [isDisclaimerFromServerSide]);

    useEffect(() => {
        const isGlobalFlow = props.stateOptions?.globalFlow;

        let backLink;
        if (props.stateOptions?.isBonus && isRepeat) {
            backLink = AUTH_PROFILE_BONUS_WITHDRAW;
        } else if (props.stateOptions?.isBonus) {
            backLink = AUTH_BONUS_WITHDRAW + (!isGlobalFlow ? `/${toLowerCase(toCountry?.code)}/delivery` : '');
        } else if (isRepeat || incompleteTransfer) {
            backLink = userComeFromSend ? AUTH_SEND : AUTH_SEND_MAIN_LINK;
        } else if (isGlobalFlow || recipientSaved) {
            backLink = AUTH_SEND;
        } else {
            backLink = `${AUTH_SEND}/${toLowerCase(toCountry?.code)}/delivery`;
        }

        if (PAYMENT_METHOD_SCREEN === screen && extra?.sendPromoStories) {
            popupFullwidthRef.current?.open(
                <PaymentStoriesModal
                    sliders={extra.sendPromoStories}
                    submitRef={submitRef}
                    popupFullwidthRef={popupFullwidthRef}
                    formName={SEND_FORM_NAME}
                    sendEvent
                    tryToCreatePrecheck={tryToCreatePrecheck}
                />,
            );
        }

        backLink += sendUriPostfix;

        setBackUrl(backLink);

        const closeFlow = (isRepeat && screen === CALCULATOR_SCREEN) || (incompleteTransfer && screen === RECIPIENT_MAIN_INFO_SCREEN);
        const binInfo = extra[BIN_EXTRA_NAME];
        if (fields) {
            GTSendMultiScreenService.toggleContinueButton(fields, screen, setDisabledSubmitButton, binInfo, props.stateOptions?.globalFlow, extra);
        }
        setCloseIcon(closeFlow);
        if (!canCalcCommission.current && screen === CALCULATOR_SCREEN) {
            canCalcCommission.current = true;
        } else if (canCalcCommission.current && screen !== CALCULATOR_SCREEN) {
            canCalcCommission.current = false;
        }

        if (screen === PAYMENT_METHOD_SCREEN) {
            const showModal = showPromoModal(ballId, extra.sendPromoStories, 'payment_promo_info');
            if (!showModal) {
                tryToCreatePrecheck();
                return;
            }
            const promoPaymentMethod = availablePaymentMethodsList[sendStoriesFromProviderCategory];
            const { commission, temporarilyUnavailableSource, method, balance } = promoPaymentMethod;
            const amountFrom = fields[AMOUNT_FROM]?.value;
            const fromRestriction = commission?.restrictionFrom;
            const bonusBalance = method === PAYMENT_BONUS ? balance : null;
            const fromAmountIssue = GTPaymentMethodService.getIssueType(
                amountFrom,
                fromRestriction?.minAmount,
                fromRestriction?.maxAmount,
                fromRestriction?.multiple,
                bonusBalance,
            );
            const isDisableForACHMethod = method === PAYMENT_ACH && canShowAmlLevelUpgrade;
            const isPaymentMethodDisabled =
                (fromAmountIssue && method !== PAYMENT_ACH && method !== PAYMENT_OFAKIM) || isDisableForACHMethod || temporarilyUnavailableSource;
            if (isPaymentMethodDisabled) {
                tryToCreatePrecheck();
                return;
            }

            popupFullwidthRef.current?.open(
                <PaymentStoriesModal
                    isMarketing={false}
                    sliders={extra.sendPromoStories}
                    submitRef={submitRef}
                    popupFullwidthRef={popupFullwidthRef}
                    formName={SEND_FORM_NAME}
                    sendEvent
                    tryToCreatePrecheck={tryToCreatePrecheck}
                />,
            );
        }

        if (screen === CALCULATOR_SCREEN && props.stateOptions?.isBonus) {
            props.updateFormProperties(SEND_FORM_NAME, `${AUTH_SEND_PRECHECK}?type=${typeOfTransfer}`, false);
        }
        if (__isBrowser__) {
            // For browser back flow from providers' websites
            query.delete('toScreen');
            const newUrl = query.toString() ? window.location.pathname + '?' + query.toString() : window.location.pathname;
            window.history.replaceState(null, '', newUrl);
        }
    }, [screen]);

    const tryToCreatePrecheck = () => {
        if (tryToCreatePrecheckAfterCalculator.current && canCreatePrecheque(availablePaymentMethodsList, dcSources, fields) && extra.sendFlowV3) {
            paymentMethodService.current.changePaymentMethod(fields?.paymentSourceFromMethod?.value, fields?.sourceCodeFrom?.value, () => {
                submitRef?.current?.click();
            });
        }
        tryToCreatePrecheckAfterCalculator.current = false;
    };

    const hasAmountRestriction = (method, fields = {}) => {
        const currentAmountFrom = Number(fields?.[AMOUNT_FROM].value);
        const currentAmountTo = Number(fields?.[AMOUNT_TO].value);

        if (
            method.commission.restrictionFrom &&
            (currentAmountFrom > method.commission.restrictionFrom.maxAmount || currentAmountFrom < method.commission.restrictionFrom.minAmount)
        ) {
            return true;
        }
        if (
            method.commission.restrictionTo &&
            (currentAmountTo > method.commission.restrictionTo.maxAmount || currentAmountTo < method.commission.restrictionTo.minAmount)
        ) {
            return true;
        }
        return false;
    };

    const canCreatePrecheque = (availablePaymentMethodsList = {}, dcSources = {}, fields = {}) => {
        let canShowPrecheck = false;
        if (sourceIsNewBankCard()) {
            return false;
        }

        Object.values(dcSources).forEach((v) => {
            if (Array.isArray(v) && v.length > 0) {
                Object.values(v).forEach((p) => {
                    if (p && p.lastSuccess) {
                        canShowPrecheck = true;
                    }
                });
            }
        });

        Object.values(availablePaymentMethodsList).forEach((method) => {
            if (method && method.lastSuccess && !hasAmountRestriction(method, fields)) {
                canShowPrecheck = true;
            }
        });
        return canShowPrecheck;
    };

    const sourceIsNewBankCard = () =>
        fields?.paymentSourceFromMethod?.value === PAYMENT_BANK_CARD && getExtra(fields?.sourceCodeFrom?.value, 'type') === EXTERNAL;

    useEffect(() => {
        if (fields) {
            let binInfo = extra[BIN_EXTRA_NAME];
            if (!isRepeat && deliveryMethod === PAYMENT_BANK_CARD && !binInfo) {
                binInfo = { error: true };
            }
            GTSendMultiScreenService.toggleContinueButton(fields, screen, setDisabledSubmitButton, binInfo, props.stateOptions?.globalFlow, extra);
            if ((showDisclaimer || isDisclaimerFromServerSide) && !disclaimerAgreed) {
                DisclaimerService.showDisclaimer(
                    props,
                    toCountry,
                    toCurrency,
                    isDisclaimerFromServerSide,
                    deliveryMethod,
                    setDisclaimerAgreed,
                    Disclaimer,
                    fields,
                    sendUriPostfix,
                    isDisclaimerFromServerSide,
                    incompleteTransfer,
                    toBankCodeRef.current,
                );
            } else if (DisclaimerService.isShowVietnamCashDisclaimerAgain(toCurrency, showDisclaimer, deliveryMethod, toBankCodeRef.current, fields)) {
                setDisclaimerAgreed(false);
                DisclaimerService.showDisclaimer(
                    props,
                    toCountry,
                    toCurrency,
                    isDisclaimerFromServerSide,
                    deliveryMethod,
                    setDisclaimerAgreed,
                    Disclaimer,
                    fields,
                    sendUriPostfix,
                    isDisclaimerFromServerSide,
                    incompleteTransfer,
                    toBankCodeRef.current,
                );
            }
            toBankCodeRef.current = DisclaimerService.getFilledToBackCodeField(fields);
        }
    }, [fields, extra[BIN_EXTRA_NAME]]);

    useEffect(() => {
        if (resetComponent) {
            resetComponentState();
        }
    }, [resetComponent]);

    const isNameAndNameFFieldsEqual = (fields = {}) => {
        if (fields?.[TO_NAME]?.value) {
            return toLowerCase(fields?.[TO_NAME]?.value) === toLowerCase(fields?.[TO_NAME_F]?.value);
        }

        return false;
    };

    const isNameAndNameFFieldsEqualToProfileData = (fields = {}) => {
        if (toLowerCase(typeOfTransfer) !== RECIPIENT_TYPE_SELF && extra.profile) {
            if ((fields?.[TO_NAME_F]?.value && fields[TO_NAME]?.value) || fields[TO_RECIPIENT]?.value || fields[TO_RECIPIENT_OTHER]?.value) {
                return (
                    (toLowerCase(fields[TO_NAME_F]?.value?.trim()) === toLowerCase(extra.profile.userLastName) &&
                        toLowerCase(fields[TO_NAME]?.value?.trim()) === toLowerCase(extra.profile.userName)) ||
                    toLowerCase(fields[TO_RECIPIENT]?.value?.replaceAll(' ', '')) === toLowerCase(extra.profile.fullName.replaceAll(' ', '')) ||
                    toLowerCase(fields[TO_RECIPIENT_OTHER]?.value?.replaceAll(' ', '')) === toLowerCase(extra.profile.fullName.replaceAll(' ', ''))
                );
            }
        }
        return false;
    };

    const sendAmplitudeEventOnContinue = () => {
        const isGlobalFlow = props.stateOptions?.globalFlow;
        const swiftDeliveryMethod = deliveryMethod === DELIVERY_SWIFT;
        const cardDeliveryMethod = deliveryMethod === DELIVERY_BANK_CARD;
        if (screen === CALCULATOR_SCREEN) {
            amplitude.getInstance().logEvent(CALCULATOR_SETTING_CHANGED, {
                [PAYOUT_COUNTRY]: toCountry?.nameEn,
                [PAYMENT_COUNTRY]: fromCountry?.nameEn,
                [PAYOUT_METHOD]: amplitudeDeliveryMethod,
                [PAYOUT_METHOD_CATEGORY]: payoutCategory,
                [PAYMENT_METHOD_AMPLITUDE]: amplitudePaymentMethod,
                [PAYMENT_METHOD_CATEGORY]: paymentCategory,
                [PAYMENT_CURRENCY]: fromCurrency?.code,
                [PAYOUT_CURRENCY]: toCurrency?.code,
                [PAYMENT_FLOW]: getPaymentFlowEventParam(),
                [AMOUNT_FROM_AMPLITUDE]: Number(fields?.[AMOUNT_FROM].value),
                [AMOUNT_TO_AMPLITUDE]: Number(fields?.[AMOUNT_TO].value),
                [IS_IMPROVED_RATE]: getIsImprovedRate(extra.commission, Number(fields?.[AMOUNT_FROM]?.value)),
                [RECIPIENT_TYPE]: getRecipientTypeParam(typeOfTransfer),
                [TRANSFER_COUNT]: transferCount !== 'no_value' ? transferCount : null,
            });
        }
        const commonParams = {
            [PAYOUT_METHOD]: amplitudeDeliveryMethod,
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
            [RECIPIENT_TYPE]: getRecipientTypeParam(typeOfTransfer),
        };
        if (screen === RECIPIENT_MAIN_INFO_SCREEN) {
            amplitude.getInstance().logEvent(RECIPIENT_DETAILS_CONTINUE_CLICKED, {
                ...commonParams,
                [CATEGORY]: RECIPIENT_MAIN_INFO,
            });
            if (!isGlobalFlow || (isGlobalFlow && (cardDeliveryMethod || (swiftDeliveryMethod && fieldsForShow)))) {
                amplitude.getInstance().logEvent(RECIPIENT_ADDED, {
                    [PAYOUT_METHOD]: amplitudeDeliveryMethod,
                    [PAYOUT_COUNTRY]: toCountry?.nameEn,
                    [RECIPIENT_TYPE]: getRecipientTypeParam(typeOfTransfer),
                });
            }
        }
        if (screen === RECIPIENT_ADDITIONAL_INFO_SCREEN) {
            amplitude.getInstance().logEvent(ADDITIONAL_RECIPIENT_CONTINUE_CLICKED, {
                ...commonParams,
                [CATEGORY]: RECIPIENT_ADDITIONAL_INFO,
            });
        }
        if (screen === TRANSFER_ADDITIONAL_INFO_SCREEN) {
            amplitude.getInstance().logEvent(MORE_DETAILS_NEEDED_CONTINUE_CLICKED, {
                ...commonParams,
                [CATEGORY]: TRANSFER_ADDITIONAL_INFO,
            });
        }
        if (screen === SENDER_ADDITIONAL_INFO_SCREEN) {
            amplitude.getInstance().logEvent(ADDITIONAL_SENDER_INFO_CONTINUE_CLICKED, {
                ...commonParams,
                [CATEGORY]: SENDER_INFO,
            });
        }
    };

    const resetComponentState = () => {
        toggleRegularFlow(true);
        setDisclaimerAgreed(false);
        clickedOnViewRatesFirst.current = false;
        toBankCodeRef.current = null;
    };

    const submitHandlerWrapper = (_responseFields, json) => {
        const cards = dcSources?.CARD;
        if (regularFlow) {
            sendMultiScreenService.current.regularSubmitHandler(
                cards,
                fields,
                messages,
                json,
                screen,
                toCountry,
                getPaymentFlowEventParam,
                availablePaymentMethodsList,
                paymentMethodState,
            );
        } else {
            sendMultiScreenService.current.rateFirstSubmitHandler(
                cards,
                fields,
                messages,
                json,
                screen,
                getPaymentFlowEventParam,
                availablePaymentMethodsList,
                paymentMethodState,
            );
        }
    };

    const switchToNextMachineScreen = () => {
        const additionalInfo = getAdditionalInfo(fields, extra);
        const {
            hasRecipientAdditionalFields,
            hasTransferAdditionalFields,
            isShowVisibleSenderAdditionalFields,
            isShowSenderAdditionalScreen,
            isShowCardExtraFields,
            hasSdkModal,
            modals,
            onlyCVV,
        } = additionalInfo;
        const screensWithoutAddFields =
            (screen === CARD_EXTRA_FIELDS_SCREEN && !hasRecipientAdditionalFields && !isShowVisibleSenderAdditionalFields && !hasTransferAdditionalFields) ||
            (screen === SENDER_ADDITIONAL_INFO_SCREEN && !hasRecipientAdditionalFields && !hasTransferAdditionalFields) ||
            (screen === RECIPIENT_ADDITIONAL_INFO_SCREEN && !hasTransferAdditionalFields);
        if (onlyCVV && extra.sendFlowV3 && (screen === TRANSFER_ADDITIONAL_INFO_SCREEN || screensWithoutAddFields)) {
            goToNextScreen();
        } else if (isBonus && screensWithoutAddFields) {
            submitRef.current.click();
        } else if (onlyCVV && (screen === TRANSFER_ADDITIONAL_INFO_SCREEN || screensWithoutAddFields)) {
            goToNextScreen();
            sendMultiScreenService.current.toggleCvvPopup(
                dcSources?.CARD,
                messages.cvvPopupTitle,
                fields[SOURCE_CODE_FROM].value,
                app.messageBody,
                errors,
                getPaymentFlowEventParam,
            );
        } else if (!onlyCVV && !hasSdkModal && screensWithoutAddFields) {
            goToNextScreen();
            submitRef.current.click();
        } else if (!onlyCVV && hasSdkModal && (screen === RECIPIENT_ADDITIONAL_INFO_SCREEN || screensWithoutAddFields)) {
            modalRef.current?.open(
                <SdkModals
                    modals={modals}
                    modalRef={modalRef}
                    popupRef={popupRef}
                    submitRef={submitRef}
                    paymentMethod={fields?.[PAYMENT_METHOD]?.value}
                    changePaymentMethodPlaid={(code, f) => {
                        paymentMethodService.current.changePaymentMethod(PAYMENT_MODULR, code, f);
                    }}
                    onClosePlaidModal={() => sendMultiScreenService.current?.changePaymentMethodOnPrecheckClose(extra.precheck, availablePaymentMethodsList)}
                />,
            );
            goToNextScreen();
        } else if (screen === CALCULATOR_SCREEN && hasExceedLimitErrors(fields)) {
            popupRef.current?.open(
                <ErrorDetailsPopup
                    isBonus={false}
                    maxAmount={extra.commission?.restrictionFrom?.maxAmount}
                    multiple={extra.commission?.restrictionFrom?.multiple}
                    currencyCode={extra.commission?.restrictionFrom?.ccyIso}
                    currencyCodeFrom={extra.commission?.restrictionFrom?.ccyIso}
                    isFrom={true}
                    amountField={fields?.[AMOUNT_FROM]}
                    popupRef={popupRef}
                    formName={SEND_FORM_NAME}
                />,
            );
        } else if (screen === PAYMENT_METHOD_SCREEN) {
            goNextScreenWithUpdateContext({
                hasCardExtraFields: isShowCardExtraFields && !onlyCVV,
                hasSenderAdditionalFields: isShowSenderAdditionalScreen && isShowVisibleSenderAdditionalFields,
                hasRecipientAdditionalFields: hasRecipientAdditionalFields,
                hasTransferAdditionalFields: hasTransferAdditionalFields,
            });
        } else {
            goToNextScreen();
        }
    };

    const bonusWithdrawFlowSwitchToNextMachineScreen = () => {
        const additionalInfo = getAdditionalInfo(fields, extra);
        const { hasSenderAdditionalOrCardsExtraFields, hasRecipientAdditionalFields, hasTransferAdditionalFields, isShowVisibleSenderAdditionalFields } =
            additionalInfo;
        const noLimitErrors = hasExceedLimitErrors(fields);
        const screensWithoutAddFields =
            (screen === CALCULATOR_SCREEN &&
                noLimitErrors &&
                !hasSenderAdditionalOrCardsExtraFields &&
                !hasRecipientAdditionalFields &&
                !isShowVisibleSenderAdditionalFields &&
                !hasTransferAdditionalFields) ||
            (screen === CARD_EXTRA_FIELDS_SCREEN && !hasRecipientAdditionalFields && !isShowVisibleSenderAdditionalFields && !hasTransferAdditionalFields) ||
            (screen === SENDER_ADDITIONAL_INFO_SCREEN && !hasRecipientAdditionalFields && !hasTransferAdditionalFields) ||
            (screen === RECIPIENT_ADDITIONAL_INFO_SCREEN && !hasTransferAdditionalFields);

        if (screensWithoutAddFields) {
            submitRef.current.click();
        } else if (screen === CALCULATOR_SCREEN && hasExceedLimitErrors(fields)) {
            if (hasExceedLimitErrors(fields)) {
                popupRef.current?.open(
                    <ErrorDetailsPopup
                        isBonus={false}
                        maxAmount={extra.commission?.restrictionFrom?.maxAmount}
                        multiple={extra.commission?.restrictionFrom?.multiple}
                        currencyCode={extra.commission?.restrictionFrom?.ccyIso}
                        currencyCodeFrom={extra.commission?.restrictionFrom?.ccyIso}
                        isFrom={true}
                        amountField={fields?.[AMOUNT_FROM]}
                        popupRef={popupRef}
                        formName={SEND_FORM_NAME}
                    />,
                );
            }
        } else {
            goToNextScreen();
        }
    };

    const resetViewRatesFirst = () => {
        clickedOnViewRatesFirst.current = false;
        toggleRegularFlow(true);
    };

    /**
     * Gets the screenValidation URL parameter for the precheck endpoint.
     * For CARD_EXTRA_FIELDS_SCREEN, SENDER_ADDITIONAL_INFO_SCREEN, RECIPIENT_ADDITIONAL_INFO_SCREEN, and TRANSFER_ADDITIONAL_INFO_SCREEN:
     * returns false if there are no next screens with fields available (matching SendScreenMachine guard logic).
     * Otherwise, uses the provided value or defaults to true for RECIPIENT_MAIN_INFO_SCREEN.
     *
     * This logic matches the guards in SendScreenMachine:
     * - HAS_SENDER_ADDITIONAL_FIELDS: isShowSenderAdditionalScreen && isShowVisibleSenderAdditionalFields
     * - HAS_RECIPIENT_ADDITIONAL_FIELDS: hasRecipientAdditionalFields
     * - HAS_TRANSFER_ADDITIONAL_FIELDS: hasTransferAdditionalFields
     *
     * @param {string} currentScreen - The current screen constant
     * @param {boolean} defaultValue - Default value for screenValidation (used for RECIPIENT_MAIN_INFO_SCREEN)
     * @param {Object} additionalInfo - Additional info object from getAdditionalInfo
     * @returns {string} - The full URL with screenValidation parameter
     */
    const getScreenValidationUrl = (currentScreen, defaultValue = true, additionalInfo = null) => {
        if (!additionalInfo) {
            additionalInfo = getAdditionalInfo(fields, extra);
        }

        let screenValidationWithoutPrecheckValue = defaultValue;

        if (currentScreen === CARD_EXTRA_FIELDS_SCREEN) {
            const hasNextScreenWithFields =
                (additionalInfo.isShowSenderAdditionalScreen && additionalInfo.isShowVisibleSenderAdditionalFields) ||
                additionalInfo.hasRecipientAdditionalFields ||
                additionalInfo.hasTransferAdditionalFields;
            screenValidationWithoutPrecheckValue = hasNextScreenWithFields;
        } else if (currentScreen === SENDER_ADDITIONAL_INFO_SCREEN) {
            const hasNextScreenWithFields = additionalInfo.hasRecipientAdditionalFields || additionalInfo.hasTransferAdditionalFields;
            screenValidationWithoutPrecheckValue = hasNextScreenWithFields;
        } else if (currentScreen === RECIPIENT_ADDITIONAL_INFO_SCREEN) {
            screenValidationWithoutPrecheckValue = additionalInfo.hasTransferAdditionalFields;
        } else if (currentScreen === TRANSFER_ADDITIONAL_INFO_SCREEN) {
            //last screen
            screenValidationWithoutPrecheckValue = false;
        }
        let url = `${AUTH_SEND_PRECHECK}?screenValidation=${screenValidationWithoutPrecheckValue}`;
        if (extra?.[BIN_EXTRA_NAME]?.warningAllowed) {
            url = `${url}&warningAllowed=true`;
        }
        return url;
    };

    const defaultScreenValidation = (e) => {
        switch (screen) {
            case PAYMENT_METHOD_SCREEN: {
                return;
            }
            case RECIPIENT_MAIN_INFO_SCREEN: {
                e.preventDefault();
                if (isNameAndNameFFieldsEqual(fields)) {
                    popupRef.current?.open(<EqualNameAndNameFPopup popupRef={popupRef} />);
                    props.setFieldError(SEND_FORM_NAME, TO_NAME_F, messages.nameNameFMatching);
                } else if (extra.sendFlowV3 && isNameAndNameFFieldsEqualToProfileData(fields)) {
                    popupRef.current?.open(<ChangeRecipientTypeToMyself popupRef={popupRef} setSearchParams={setSearchParams} />);
                } else {
                    sendMultiScreenService.current.screenValidation(
                        getScreenValidationUrl(screen, true),
                        props,
                        fields,
                        messages,
                        toCountry?.highRisk,
                        controllerRef,
                        switchToNextMachineScreen,
                        screen,
                        resetViewRatesFirst,
                        false,
                        hideRecipientSaved,
                        incompleteTransfer,
                        incompleteTransferValidationStep,
                        typeOfTransfer,
                        availablePaymentMethodsList,
                        undefined,
                        clickedOnViewRatesFirst.current === true,
                    );
                }
                return;
            }
            case RECIPIENT_ADDITIONAL_INFO_SCREEN: {
                e.preventDefault();
                const additionalData = getAdditionalInfo(fields, extra);
                sendMultiScreenService.current.screenValidation(
                    getScreenValidationUrl(screen, false, additionalData),
                    props,
                    fields,
                    messages,
                    toCountry?.highRisk,
                    controllerRef,
                    switchToNextMachineScreen,
                    screen,
                    resetViewRatesFirst,
                    !additionalData.hasSdkModal && !additionalData.onlyCVV && !additionalData.isShowTransferAdditionalFields,
                    undefined,
                    undefined,
                    undefined,
                    typeOfTransfer,
                    availablePaymentMethodsList,
                    undefined,
                    clickedOnViewRatesFirst.current === true,
                );
                return;
            }
            case SENDER_ADDITIONAL_INFO_SCREEN:
            case CARD_EXTRA_FIELDS_SCREEN: {
                e.preventDefault();
                const recipientAdditionalFields = getRecipientAdditionalFields(fields);
                const additionalData = getAdditionalInfo(fields, extra);
                sendMultiScreenService.current.screenValidation(
                    getScreenValidationUrl(screen, false, additionalData),
                    props,
                    fields,
                    messages,
                    toCountry?.highRisk,
                    controllerRef,
                    switchToNextMachineScreen,
                    screen,
                    resetViewRatesFirst,
                    recipientAdditionalFields.length === 0 && !additionalData.isShowVisibleSenderAdditionalFields,
                    undefined,
                    undefined,
                    undefined,
                    typeOfTransfer,
                    availablePaymentMethodsList,
                    paymentMethodState,
                    clickedOnViewRatesFirst.current === true,
                );
                return;
            }
            case TRANSFER_ADDITIONAL_INFO_SCREEN: {
                e.preventDefault();
                const additionalData = getAdditionalInfo(fields, extra);
                sendMultiScreenService.current.screenValidation(
                    getScreenValidationUrl(screen, false, additionalData),
                    props,
                    fields,
                    messages,
                    toCountry?.highRisk,
                    controllerRef,
                    switchToNextMachineScreen,
                    screen,
                    resetViewRatesFirst,
                    !additionalData.hasSdkModal && !additionalData.onlyCVV,
                    undefined,
                    undefined,
                    undefined,
                    typeOfTransfer,
                    availablePaymentMethodsList,
                    undefined,
                    clickedOnViewRatesFirst.current === true,
                );
                return;
            }
            default: {
                e.preventDefault();
                switchToNextMachineScreen();
            }
        }
    };

    const bonusScreenValidation = (e) => {
        const isRegular = regularFlow && !clickedOnViewRatesFirst.current;
        const isGlobalSwift = props.stateOptions?.globalFlow && deliveryMethod === DELIVERY_SWIFT;
        const additionalInfo = getAdditionalInfo(fields, extra);
        const { isShowSenderAdditionalScreen, isShowVisibleSenderAdditionalFields, isShowTransferAdditionalFields } = additionalInfo;
        if (isGlobalSwift && screen === RECIPIENT_MAIN_INFO_SCREEN) {
            defaultScreenValidation(e);
            return 0;
        } else {
            if (
                isBonus &&
                !isShowSenderAdditionalScreen &&
                !isShowVisibleSenderAdditionalFields &&
                !isShowTransferAdditionalFields &&
                screen === CALCULATOR_SCREEN &&
                isRegular
            ) {
                return 0;
            } else if (screen === RECIPIENT_MAIN_INFO_SCREEN) {
                defaultScreenValidation(e);
                return 0;
            } else if (screen === RECIPIENT_ADDITIONAL_INFO_SCREEN || screen === CARD_EXTRA_FIELDS_SCREEN || screen === TRANSFER_ADDITIONAL_INFO_SCREEN) {
                defaultScreenValidation(e);
                return 0;
            } else {
                e.preventDefault();
                bonusWithdrawFlowSwitchToNextMachineScreen();
            }
        }
    };

    const screenValidation = (e) => {
        if (props.stateOptions?.isBonus) {
            bonusScreenValidation(e);
        } else {
            defaultScreenValidation(e);
        }
    };

    const viewRatesFirst = (e) => {
        e.preventDefault();
        clickedOnViewRatesFirst.current = true;
        toggleRegularFlow(false);
        goToNextScreenMachineViewRatesFirst();
        amplitude.getInstance().logEvent(VIEW_RATES_FIRST, {
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
            [PAYOUT_METHOD]: amplitudeDeliveryMethod,
            [PAYMENT_FLOW]: NEW,
            [RECIPIENT_TYPE]: getRecipientTypeParam(typeOfTransfer),
        });
    };

    const returnToCalculator = () => {
        goPreviousScreen();
    };

    const showPaymentMethodScreen = () => {
        goPreviousScreen();
    };

    const onBackIconClickForMachine = (e) => {
        if (!closeIcon) {
            if (regularFlow) {
                if (
                    screen === SUB_SOURCES_SCREEN ||
                    (screen === RECIPIENT_MAIN_INFO_SCREEN && !toSubSources && !showCalculatorFirst) ||
                    (screen === CALCULATOR_SCREEN && showCalculatorFirst)
                ) {
                } else {
                    goPreviousScreen();
                    e.preventDefault();
                }
            } else {
                sendMultiScreenService.current.viewRateFirstBackFlowForMachine(e, screen, resetViewRatesFirst);
            }
        }
    };

    if ((isRepeat || incompleteTransfer) && transferMethodNotSupport) {
        const repeatBackUrl = userComeFromSend ? AUTH_SEND : AUTH_SEND_MAIN_LINK;
        return (
            <InfoPage
                animatedIconFail
                headerText={messages.transferMethodNotSupport}
                primaryButtonType="link"
                primaryButtonCaption={messages.goBack}
                primaryButtonLink={repeatBackUrl}
            />
        );
    }

    const disclaimerWasShown = () => {
        isShowDisclaimer.current = false;
    };

    /**
     * закинуть в отдельный хелпер для машины
     */
    const goPreviousScreen = () => {
        send({ type: 'BACK' });
    };

    const goToNextScreen = () => {
        send({ type: 'NEXT' });
    };

    const goToNextScreenMachineViewRatesFirst = () => {
        send({ type: 'GO_TO_VIEW_RATES_FLOW' });
    };

    const goNextScreenWithUpdateContext = (newContext) => {
        send({ type: 'NEXT_WITH_UPDATE_CONTEXT ', data: { ...newContext } });
    };

    const sendAmplitudeEventOnRender = (eventName) => {
        const sourceCodeToValue = fields?.sourceCodeTo?.value;
        const baseParams = {
            [PAYOUT_COUNTRY]: toCountry?.nameEn,
            [PAYOUT_METHOD]: amplitudeDeliveryMethod,
            [RECIPIENT_TYPE]: getRecipientTypeParam(typeOfTransfer),
        };
        const additionalParams = {
            [PAYMENT_COUNTRY]: fromCountry?.nameEn,
            [PAYMENT_CURRENCY]: fromCurrency?.code,
            [PAYOUT_CURRENCY]: toCurrency?.code,
            [PAYMENT_METHOD_AMPLITUDE]: amplitudePaymentMethod,
            [PAYMENT_METHOD_CATEGORY]: paymentCategory,
            [PAYOUT_METHOD_CATEGORY]: payoutCategory,
            [IS_IMPROVED_RATE]: getIsImprovedRate(extra?.commission, Number(fields?.[AMOUNT_FROM]?.value)),
        };
        const addTransferCount = (params) => ({
            ...params,
            [TRANSFER_COUNT]: transferCount !== 'no_value' ? transferCount : null,
        });
        const logEvent = (params) => amplitude.getInstance().logEvent(eventName, params);

        if (deliveryMethod === DELIVERY_CASH_UNITELLER && toSubSources) {
            if (screen === SUB_SOURCES_SCREEN) {
                return logEvent(baseParams);
            }
            const networkName = getSubSourceName(sourceCodeToValue, toSubSources);
            if (!networkName) return;
            const paramsWithNetwork = { ...baseParams, [NETWORK]: networkName };
            const params = screen === CALCULATOR_SCREEN ? { ...paramsWithNetwork, ...additionalParams } : paramsWithNetwork;
            return logEvent(params);
        }
        let params = baseParams;
        if (screen === CALCULATOR_SCREEN) {
            params = addTransferCount({ ...baseParams, ...additionalParams });
        } else if (screen === RECIPIENT_MAIN_INFO_SCREEN) {
            params = addTransferCount({ ...baseParams, [CATEGORY]: RECIPIENT_MAIN_INFO });
        } else if (screen === RECIPIENT_ADDITIONAL_INFO_SCREEN) {
            params = addTransferCount({ ...baseParams, [CATEGORY]: RECIPIENT_ADDITIONAL_INFO });
        } else if (screen === TRANSFER_ADDITIONAL_INFO_SCREEN) {
            params = addTransferCount({ ...baseParams, [CATEGORY]: TRANSFER_ADDITIONAL_INFO });
        } else if (screen === SENDER_ADDITIONAL_INFO_SCREEN) {
            params = addTransferCount({ ...baseParams, [CATEGORY]: SENDER_INFO });
        }
        logEvent(params);
    };

    const getPaymentFlowEventParam = () => {
        return getPaymentFlow(repeatDraft, isRepeat, userComeFromSend);
    };

    const hideRecipientSaved = () => {
        return incompleteTransfer && !recipientDataChanged;
    };

    const saveIncompleteTransferInfo = () => {
        if (screen === CALCULATOR_SCREEN && (!fields[REPEAT_PAYMENT_ID] || !fields[REPEAT_PAYMENT_ID]?.value)) {
            ApiService.fetchWithoutSpinner(AUTH_SEND_INCOMPLETE_PAYMENT_CALCULATOR_ACTION + sendUriPostfix, fields);
        }
    };

    const getContinueButtonCaption = (fields, screen, messages) => {
        if (screen === CARD_EXTRA_FIELDS_SCREEN && fields && PAN === fields[FROM_ACCOUNT]?.type) {
            return messages.cardsAddBankCardButton;
        }
        return messages.continue;
    };

    return (
        <>
            <CommonPage backUrl={backUrl} hasBottomPanel leftCloseIcon={closeIcon} onClickIcon={onBackIconClickForMachine}>
                {fields && (
                    <Form formName={SEND_FORM_NAME} action={AUTH_SEND_PRECHECK + sendUriPostfix} getCanonicalPath={true} onSubmitHandler={submitHandlerWrapper}>
                        {screen === SUB_SOURCES_SCREEN && (
                            <ToSubSources
                                subSource={toSubSources}
                                isShowDisclaimer={isShowDisclaimer.current}
                                disclaimerWasShown={disclaimerWasShown}
                                typeOfTransfer={typeOfTransfer}
                                sendUriPostfix={sendUriPostfix}
                                setNextScreen={() => {
                                    switchToNextMachineScreen();
                                }}
                                sendAmplitudeEventOnRender={sendAmplitudeEventOnRender}
                            />
                        )}
                        {screen === RECIPIENT_MAIN_INFO_SCREEN && (
                            <GTToFields
                                formName={SEND_FORM_NAME}
                                fields={GTSendMultiScreenService.getVisibleFields(fields, screen, sendMultiScreenService.current?.getFieldsForShow())}
                                regularFlow={regularFlow}
                                viewRatesFirst={viewRatesFirst}
                                submitRef={submitRef}
                                isGlobalFlow={props.stateOptions?.globalFlow}
                                isBonusWithdraw={props.stateOptions?.isBonus}
                                hideViewRatesFirst={props.stateOptions?.hideViewRatesFirst || showCalculatorFirst}
                                isPayee={isPayee}
                                sendUriPostfix={sendUriPostfix}
                                typeOfTransfer={typeOfTransfer}
                                incompleteTransfer={incompleteTransfer}
                                binInfoExtraName={BIN_EXTRA_NAME}
                                sendAmplitudeEventOnRender={sendAmplitudeEventOnRender}
                                setRecipientDataChanged={setRecipientDataChanged}
                                setDisabledSubmitButton={setDisabledSubmitButton}
                                popupFullwidthRef={popupFullwidthRef}
                                allFields={fields}
                            />
                        )}
                        {screen === CALCULATOR_SCREEN && (
                            <SendCalculatorScreen
                                formName={SEND_FORM_NAME}
                                isBonus={isBonus}
                                isRepeat={isRepeat}
                                isCanCalcCommission={canCalcCommission.current}
                                checkFieldsAndSubmitFormIfHasNoErrors={switchToNextMachineScreen}
                                isGlobalFlow={props.stateOptions?.globalFlow}
                                submitRef={submitRef}
                                typeOfTransfer={typeOfTransfer}
                                sendAmplitudeEventOnRender={sendAmplitudeEventOnRender}
                                setDisabledSubmitButton={setDisabledSubmitButton}
                                lang={lang}
                                country={app.country}
                                onBeforeCurrencyChange={() => sendMultiScreenService.current?.markCurrencyChange()}
                            />
                        )}
                        {screen === PAYMENT_METHOD_SCREEN && (
                            <GTPaymentMethods
                                formName={SEND_FORM_NAME}
                                returnToCalculator={returnToCalculator}
                                submitRef={submitRef}
                                modalRef={modalRef}
                                popupFullwidthRef={popupFullwidthRef}
                                isGlobalFlow={props.stateOptions?.globalFlow}
                                sendAmplitudeEventOnRender={sendAmplitudeEventOnRender}
                                getPaymentFlow={getPaymentFlowEventParam}
                                typeOfTransfer={typeOfTransfer}
                                popupRef={popupRef}
                                paymentMethodState={paymentMethodState}
                                toCountryCode={toCountry?.code}
                                toCurrencyCode={toCurrency?.code}
                                isIncomplete={incompleteTransfer}
                            />
                        )}
                        {screen === CARD_EXTRA_FIELDS_SCREEN && (
                            <GTFromFields
                                showPaymentMethodScreen={showPaymentMethodScreen}
                                formName={SEND_FORM_NAME}
                                fields={GTSendMultiScreenService.getVisibleFields(fields, screen, null, extra)}
                                showPaymentFields={true}
                                showFromFields={false}
                            />
                        )}
                        {screen === SENDER_ADDITIONAL_INFO_SCREEN && (
                            <GTFromFields
                                formName={SEND_FORM_NAME}
                                screen={screen}
                                fields={GTSendMultiScreenService.getVisibleFields(fields, screen)}
                                showPaymentFields={false}
                                showFromFields={true}
                                changeFormField={props.changeFormField}
                                sendAmplitudeEventOnRender={sendAmplitudeEventOnRender}
                            />
                        )}
                        {screen === RECIPIENT_ADDITIONAL_INFO_SCREEN && (
                            <GTExtraToFields
                                formName={SEND_FORM_NAME}
                                screen={screen}
                                fields={GTSendMultiScreenService.getVisibleFields(fields, screen)}
                                typeOfTransfer={typeOfTransfer}
                                incompleteTransfer={incompleteTransfer}
                                showPaymentFields={false}
                                showFromFields={true}
                                sendAmplitudeEventOnRender={sendAmplitudeEventOnRender}
                            />
                        )}
                        {screen === TRANSFER_ADDITIONAL_INFO_SCREEN && (
                            <GTExtraToFields
                                formName={SEND_FORM_NAME}
                                screen={screen}
                                fields={GTSendMultiScreenService.getVisibleFields(fields, screen)}
                                typeOfTransfer={typeOfTransfer}
                                incompleteTransfer={incompleteTransfer}
                                showPaymentFields={false}
                                showFromFields={true}
                                sendAmplitudeEventOnRender={sendAmplitudeEventOnRender}
                            />
                        )}
                        {screen !== SUB_SOURCES_SCREEN && (
                            <FixedBottomPanel isRightAligned={screen !== CALCULATOR_SCREEN}>
                                <Button
                                    type="submit"
                                    ref={submitRef}
                                    raised={true}
                                    disabled={disabledSubmitButton}
                                    variant={screen === PAYMENT_METHOD_SCREEN ? 'hidden' : null}
                                    onClick={(e) => {
                                        screenValidation(e);
                                        sendAmplitudeEventOnContinue();
                                        saveIncompleteTransferInfo();
                                    }}
                                    caption={getContinueButtonCaption(fields, screen, messages)}
                                />
                            </FixedBottomPanel>
                        )}
                    </Form>
                )}
            </CommonPage>
            <PopupNew ref={popupRef} />
            <PopupNew ref={popupFullwidthRef} fullwidthPopup />
            <GTSendModals modalRef={modalRef} />
        </>
    );
};

export default connect(null, {
    scrollToField,
    setFieldError,
    changeFieldProperty,
    setFieldVisible,
    changeFormField,
    changeFormFieldValue,
    updateFieldValues,
    updateFields,
    updateFormProperties,
    toggleModal,
    setNewFields,
    addExtras,
    setExtra,
    updatePageMessages,
    updateMessages,
    setNewForm,
    toggleSpinner,
    removeFields,
    toggleModalWithTimer,
})(BasePage(GTSendMultiPage));
